import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'antd';
import { getSafe } from '../../../shared/utility';
// import { resetVncData } from '../../../store/actions/JobConfiguration/index';
import Modal from '../../../components/UI/Modal/Modal';

import { API_PATHS, ERROR_TYPES } from '../../../shared/apiConsts';
import {
  SOCKET_PROXY_TARGET,
  DISCONNECT_MODAL_CONTENT,
  PASSWORD_KEY,
  JOB_ID_KEY,
  VNC_SERVER_KEY,
  MSG_DISCONNECT,
  MSG_NO_CONNECTION,
  DISCONNECT_MODAL_TITLE,
  DISCONNECT_MODAL_CANCEL_BTN,
  DISCONNECT_MODAL_REMOVE_BTN,
  STARTING_PORT,
} from './VNCConsts';
import VncClient from './VNC/VncClient';
import ActionBar from './VNC/ActionBar';

import './VNCViewer.scss';
import { EXTERNAL_WINDOWS } from '../../../shared/const/Routes/statePaths';
import {
  removeJobFromState,
  unsetExternalWindow,
} from '../../../store/actions/netbatchJobs/netbatchJobs';

const VNCViewer = props => {
  const dispatch = useDispatch();
  const [errorMsg, setErrorMsg] = useState('initialState');
  const vncData = props.job;
  const [jobId, setJobId] = useState('');
  const [server, setServer] = useState('');
  const [port, setPort] = useState('');
  const [password, setPassword] = useState('');
  const [vncDisplay, setVncDisplay] = useState('');
  const [isModalVisible, setIsModalVisible] = useState('');
  const [loadingStatus, setLoadingStatus] = useState(true);
  const externalWindows = useSelector(state =>
    getSafe(EXTERNAL_WINDOWS, state)
  );

  useEffect(() => {
    if (vncData) {
      let serverAddress = vncData[VNC_SERVER_KEY];
      setVncDisplay(serverAddress);
      if (serverAddress) {
        setJobId(vncData[JOB_ID_KEY]);
        setServer(serverAddress.substring(0, serverAddress.lastIndexOf(':')));
        setPort(serverAddress.substring(serverAddress.lastIndexOf(':') + 1));
        setPassword(vncData[PASSWORD_KEY]);
      } else {
        setErrorMsg(MSG_NO_CONNECTION);
      }
    } else {
      setErrorMsg(MSG_NO_CONNECTION);
    }
    setIsModalVisible(false);
  }, []);

  useEffect(() => {
    if (externalWindows[jobId]) {
      externalWindows[jobId].window.addEventListener('unload', disconnect);
      return () => {
        externalWindows[jobId].window.removeEventListener('unload', disconnect);
      };
    }
  }, [externalWindows]);

  const removeAndCloseWin = (keepJob = true) => {
    dispatch(removeJobFromState(jobId, keepJob));
    if (externalWindows[jobId]) {
      externalWindows[jobId].window.close();
      dispatch(unsetExternalWindow(jobId));
    }
  };

  const onVNCDisconnect = () => {
    removeAndCloseWin();
  };

  //   const callNB = async apiPath => {
  //     const params = { jobID: jobId };
  //     let data = await deleteRequest(
  //       apiPath,
  //       ERROR_TYPES.JOB_CONFIGURATION,
  //       params
  //     );
  //     return data;
  //   };

  //should be remove and use setIsModalVisible?
  const changeModalVisibility = isVisible => {
    setIsModalVisible(isVisible);
  };

  const disconnect = () => {
    // dispatch(resetVncData());
    setJobId(null);
    setServer(null);
    setPort(null);
    setPassword(null);
    setErrorMsg(MSG_DISCONNECT);

    changeModalVisibility(false);
    if (externalWindows[jobId]) {
      externalWindows[jobId].window.close();
      dispatch(unsetExternalWindow(jobId));
    }
  };

  const removeJob = async () => {
    changeModalVisibility(false);

    // const removeResult = await callNB(API_PATHS.NB_REMOVE_JOB);
    removeAndCloseWin(false);
    // if (!!removeResult) dispatch(setDisconnectVnc(removeResult));
  };

  const getDisconnectModal = () => {
    return (
      <Modal
        title={DISCONNECT_MODAL_TITLE}
        footer={[
          <Button key="back" onClick={() => changeModalVisibility(false)}>
            {DISCONNECT_MODAL_CANCEL_BTN}
          </Button>,
          <Button key="disconnect" type="primary" onClick={disconnect}>
            {DISCONNECT_MODAL_TITLE}
          </Button>,
          <Button key="remove" type="primary" onClick={removeJob}>
            {DISCONNECT_MODAL_REMOVE_BTN}
          </Button>,
        ]}
        visible={isModalVisible}
        onCancel={() => changeModalVisibility(false)}
        jobId={jobId}
      >
        {DISCONNECT_MODAL_CONTENT}
      </Modal>
    );
  };

  let fullPort = STARTING_PORT + parseInt(port);

  return (
    <>
      {server && (
        <VncClient
          jobId={jobId}
          vncDisplay={vncDisplay}
          host={server}
          port={fullPort}
          path={SOCKET_PROXY_TARGET}
          password={password}
          isSecure={false}
          onDisconnect={onVNCDisconnect}
          actionsBar={props => (
            <ActionBar
              server={server}
              port={port}
              jobid={jobId}
              showModal={changeModalVisibility}
              {...props}
            />
          )}
        />
      )}
      {getDisconnectModal()}
    </>
  );
};

export default VNCViewer;
